import React, { useMemo } from 'react';
import type { LtipFormStat } from '../../utils/ltipFormStats';
import './LtipFormDistributionChart.css';

const BAR_COLORS = ['#073763', '#1155cc', '#1a237e', '#283593', '#3f51b5', '#5c6bc0', '#6d9eeb'];

/** Компактная шкала: длина полосы — доля от лидера в этой строке, подпись — фактический %. */
const INSIDE_LABEL_MIN_VISUAL_PCT = 22;

type LtipFormDistributionChartProps = {
  stats: LtipFormStat[];
};

const LtipFormDistributionChart: React.FC<LtipFormDistributionChartProps> = ({ stats }) => {
  const maxPct = useMemo(
    () => Math.max(...stats.map((item) => item.percentage), 1),
    [stats],
  );

  if (stats.length === 0) {
    return (
      <div className="ltip-form-chart ltip-form-chart--empty">
        Нет данных по формам LTIP
      </div>
    );
  }

  return (
    <div className="ltip-form-chart" role="img" aria-label="Распределение форм LTIP">
      {stats.map((item, index) => {
        const barColor = BAR_COLORS[index % BAR_COLORS.length];
        const pctLabel = `${Math.round(item.percentage)}%`;
        const visualPct = (item.percentage / maxPct) * 100;
        const showInside = visualPct >= INSIDE_LABEL_MIN_VISUAL_PCT;

        return (
          <div key={item.label} className="ltip-form-chart-row">
            <div className="ltip-form-chart-label" title={item.label}>
              {item.label}
            </div>
            <div className="ltip-form-chart-bar-wrap">
              <div className="ltip-form-chart-grid" aria-hidden="true">
                {[0, 25, 50, 75, 100].map((tick) => (
                  <span key={tick} className="ltip-form-chart-grid-line" style={{ left: `${tick}%` }} />
                ))}
              </div>
              <div
                className="ltip-form-chart-bar"
                style={{
                  width: `${visualPct}%`,
                  backgroundColor: barColor,
                }}
              />
              {showInside ? (
                <span
                  className="ltip-form-chart-pct ltip-form-chart-pct--inside"
                  style={{ left: `${visualPct}%` }}
                >
                  {pctLabel}
                </span>
              ) : (
                <span
                  className="ltip-form-chart-pct ltip-form-chart-pct--outside"
                  style={{ left: `${visualPct}%` }}
                >
                  {pctLabel}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LtipFormDistributionChart;
